const landingDictES = {
  home: "Inicio",
  benefits: "Beneficios",
  benefitsExplanation: "Nuestra plataforma es una herramienta moderna, de fácil acceso y rentable.",
  firstBenefit: "Mayor integración comercial",
  secondBenefit: "Economía más ligera y potente",
  thirdBenefit: "Oportunidad de ganancias instantáneas y consistentes",
  fourthBenefit: "Generar crédito",
  features: "Características",
  howItWorks: "Cómo funciona",
  meetOurPlans: "Conozca nuestros planes",
  join: "Nuestros planes",
  plans: "Planes",
  login: "Entrar",
  whatIsIt: "El marketplace que siempre te premia",
  whatIsItExplanation:
    "Extraconomy es una plataforma online de economía cooperativa con un sistema de recompensas y geolocalización que permite a particulares y empresas incrementar su poder económico y su red de clientes de forma automática y progresiva, a través de las distintas actividades que realizan en el mercado.",
  why: "Por qué?",
  greaterBusiness: "Mayor integración comercial",
  lighterPowerful: "Economia más ligera y potente",
  instantProfit: "Oportunidad de beneficio instantáneo y constante",
  genCredit: "Genere crédito",
  whyShould: "Por qué debo unirme a la Extraconomy?",
  seeBelow: "Vea a continuación los recursos de nuestra red social y económica:",
  extracredit: "Extracredit",
  extracoinExplanation:
    "Regístrate y gana Extracredit (ver condiciones). Usa el crédito para comprar y/o compartir con tus amigos.",
  indicate: "Gane Créditos Extracredit",
  youMayGain: "Refiera usuarios a su red y gane créditos Extracredit y dinero real.",
  economicNetwork: "Red Económica",
  networkOfUsers: "Cree una red de usuarios para comprar y vender productos y servicios.",
  transactionSafety: "Seguridad de transacciones",
  ourPlatform:
    "Nuestra plataforma es robusta y segura. Puedes comprar, vender y transferir dinero de forma segura.",
  findEverything: "Encuentra todo lo que necesitas",
  weHavePowerfulTool:
    "Disponemos de una potente herramienta para encontrar el producto que desea adquirir en tan solo unos clics.",
  buyerReviews: "Reseñas de compradores",
  checkTheReviews:
    "Consulta las opiniones de los usuarios que han comprado el producto que buscas.",
  geolocation: "Geolocalización",
  effectiveTools: "Herramientas efectivas para hacer crecer automáticamente tu red económica.",
  exceptionalTrading: "Negocios Excepcionales",
  saferMoreFrequent: "Intercambios más seguros, frecuentes y ventajosos.",
  economicInfluence: "Influencia Económica",
  sellFaster: "Haga ventas más rápidas, compre más fácilmente, siempre obteniendo ganancias.",
  howItWorksExplanation:
    "Recibes recompensas por cada actividad que se realiza en la plataforma, en forma de dinero y créditos Extracredit que pueden ser utilizados dentro del sistema como complemento económico en intercambios comerciales.",
  contactWhatTele:
    "Para obtener información sobre el proyecto y sobre la apertura del mercado para Partners y Managers en un País, escriba a los seguientes contactos de Whatsapp y Telegram.",
  joinExtraconomy: "Únete a la Extraconomy.",
  belowArePlans: "A continuación se muestran los tipos de planes disponibles en nuestro servicio.",
  learnMore: "Más Información",
  doubts: "¿Dudas? ",
  contactToUs: "Contáctenos.",
  contact: "Contacto",
  scanQRCode: "Escanee el Código QR a continuación para contactarnos vía WhatsApp o Telegram:",
  highlights: "Destacados",
  by: " por ",
  video: "Video",
  introVideo: "Video de introducción sobre nuestra plataforma:",
  backToHomePage: "Volver a la Página de Inicio",
  qrCodeExplanation:
    "Para obtener información sobre el proyecto y sobre la apertura del mercado para Partners y Managers en un País, escriba a los seguientes contactos de Whatsapp y Telegram:",
  socialMedia: "Redes Sociales",
  rightsReserved: "Reservados todos los derechos",
  checkApp: "Consulta nuestra aplicación",
  customerDescription: "Solo para compras",
  partnerDescription: "Para ventas y compras",
  managerDescription: "Comercio electrónico + Compras",
  benefitsExtracoinSection: "Beneficios al comprar Extracoin",
  extracoinBenefitTitle1: "2.000 Extracoins: ¡Conviértase en Partner de Extraconomy!",
  extracoinBenefitDescription1:
    "Los poseedores de 2000 Extracoins reciben un vale gratuito para convertirse en Partners en Extraconomy Marketplace. Únase a la revolución y participe activamente en la configuración del futuro de la economía digital.",
  extracoinBenefitTitle2: "5.000 Extracoins: ¡Desbloquee el estado de Seller en Extraconomy!",
  extracoinBenefitDescription2:
    "Los poseedores de 5.000 Extracoins son recompensados con un cupón gratuito para convertirse en Sellers en la plataforma Extraconomy. Muestre sus productos y servicios a una audiencia global.",
  extracoinBenefitTitle3: "15.000 Extracoins: ¡Alcanza el estatus de Manager en Extraconomy!",
  extracoinBenefitDescription3:
    "Los poseedores de 15.000 Extracoins reciben un vale exclusivo para convertirse en Managers de Extraconomy. Sumérgete en el universo de la gestión y contribuye al crecimiento de todo el ecosistema.",
  voucherExtracoinText1: "¿Ya tienes un ",
  clickHere: "Haga clic aquí",
  andRegister: " y regístrese",
  voucherEmptyError: "El campo del cupón no puede estar vacío.",
  extracoinVoucherError: "El cupón ingresado no es válido.",
  startsWith: "Comienza con",
  contains: "Contiene",
  notContains: "No contiene",
  endsWith: "Termina con",
  equals: "igual",
  notEquals: "no es igual",
  noFilter: "Sin filtro",
  joinTheLaunchpad: "¡Únase al Launchpad de nuestro token Extracoin en Cryptosmart!",
  popupDesc:
    "¡Al comprar tokens EXC a un precio especial, recibirás a cambio un voucher gratis para abrir una tienda en línea en el mercado Extraconomy, activando tus ingresos diarios!",
  exclusiveBenefits: "Beneficios Exclusivos",
  popupPartnerTitle: "¡Convertirse en un Partner!",
  popupPartnerDesc:
    "*Al comprar un mínimo de 2000 Extracoin, recibirás un voucher gratuito para abrir un punto de venta en el mercado Extraconomy.",
  popupSellerTitle: "¡Desbloquea el perfil de Seller!",
  popupSellerDesc:
    "*Al comprar al menos 5.000 Extracoin recibirás un voucher gratis para abrir un comercio electrónico en la plataforma Extraconomy.",
  popupManagerTitle: "¡Alcanza el estatus de Manager!",
  popupManagerDesc:
    "*Al comprar un mínimo de 15.000 Extracoin recibirás un voucher exclusivo para abrir una tienda online en Extraconomy con todos los beneficios incluidos.",
  promotionValidUntilEndLaunchpad: "Promoción válida hasta el final de Launchpad",
  downloadAppAndEarn: "Descarga la aplicación ahora y gana 20 euros en créditos de inmediato",
  frequentlyAskedQuestion: "Preguntas frecuentes",
  faqTitle1: "¿La plataforma Extraconomy es segura?",
  faqAnswer1:
    "Sí, contamos con un equipo técnico especializado en seguridad de la información. Todos los contenidos, datos y operaciones financieras de la plataforma están protegidos contra múltiples niveles de seguridad, de modo que podamos mitigar al máximo cualquier tipo de ataque informático comprobable.",
  faqTitle2: "¿Cómo puedo participar en la plataforma?",
  faqAnswer2:
    "Si descubriste Extraconomy a través de alguien, ellos saben cómo incorporarte a la plataforma. En caso contrario, descarga nuestra App y regístrate introduciendo tus datos para acceder directamente a la Tienda. ¡Recibirás un crédito de bienvenida para utilizar en tus futuras compras!",
  faqTitle3: "¿Existen tarifas de registro para poder vender mis productos o servicios?",
  faqAnswer3:
    "Sí, para tener un espacio para tu escaparate o para tu e-commerce existen 3 planes de ventas con diferentes valores y beneficios dependiendo de las necesidades de cada usuario particular y empresarial. Puedes descubrir los Planes directamente aquí en esta web.",
  faqTitle4:
    "Cuando realizo actividades de promoción y ventas en la plataforma Extraconomy, ¿tengo una relación laboral?",
  faqAnswer4:
    "No, si te has suscrito a uno de los 3 planes de venta serás autónomo y serás totalmente responsable de tus gastos. Sólo si decides trabajar con nosotros como Promotor recibirás un contrato de Representante de Ventas.",
  faqTitle5: "¿Cómo puedo solicitar la eliminación de mi cuenta?",
  faqAnswer5:
    "Para cancelar tu cuenta Extraconomy simplemente inicia sesión en tu Área Personal y luego haz clic en Editar Perfil para solicitar la cancelación de la cuenta sin coste adicional. También puede enviar un mensaje de WhatsApp al +39 351 767 0019 con el asunto “Cancelación de Cuenta”.",
  faqTitle6: "Soy nuevo en la plataforma, ¿hay algún soporte?",
  faqAnswer6:
    "Sí, contamos con soporte humanizado y dedicado para ayudarte cuando lo necesites a través de los canales de Whatsapp y Telegram que puedes encontrar entre nuestros contactos aquí en el sitio web.",
  faqTitle7: "Proporcioné el correo electrónico incorrecto, ¿y ahora qué?",
  faqAnswer7:
    "Para cambiar su correo electrónico, deberá enviar un mensaje a WhatsApp +39 351 767 0019 con el asunto “Cambiar correo electrónico”, proporcionando todos los datos de registro utilizados durante el registro y la dirección de correo electrónico correcta.",
  faqTitle8: "¿Cuáles son las opciones de pago?",
  faqAnswer8:
    "A través de PayPal, nuestra pasarela de pago internacional, podrás pagar tu pedido mediante tarjeta de crédito, tarjeta de débito o cuenta bancaria.",
  faqTitle9: "¿Cuánto cuesta el envío a mi región?",
  faqAnswer9:
    "Para este cálculo, la forma más sencilla es simular su pedido. Elige los artículos con Envío Pagado, agrégalos al carrito y completa la compra, introduce tus datos correctamente (muy importante) y al finalizar el pedido la web te mostrará el coste de envío correcto. Si solo está simulando, no haga clic en Pagar y no resultará en ninguna compra real de su parte. Luego edite los artículos y las cantidades para ver las diferencias, siéntase libre.",
  faqTitle10: "¿Cómo funcionan los créditos adquiridos en Extraconomy?",
  faqAnswer10:
    "Los créditos internos se adquieren a través de las diversas actividades realizadas en la plataforma (Registros, Compra-Venta y Compartir) en forma de cashbacks, premios y bonificaciones, los cuales pueden ser utilizados de forma complementaria en compras dentro de la plataforma o en actividades de marketing. en base a las condiciones de uso previstas para cada perfil de usuario.",
  faqTitle11:
    "¿Cómo puedo monitorear y administrar mis pagos, comisiones y bonos recibidos en Extraconomy?",
  faqAnswer11:
    "Al registrarte a través de la Web y la App, recibes una oficina virtual en tu Área Personal donde podrás controlar todos tus ingresos financieros directos y los de tu círculo económico.",
  faqTitle12: "¿Cómo recibo mis ingresos financieros?",
  faqAnswer12:
    "Los ingresos económicos directos e indirectos se acreditan en tu cuenta PayPal, que deberás introducir en tu Área Personal. Si no tiene una cuenta PayPal, puede crear una gratis en www.paypal.com.",
  SeeTheRegulationsHere: "Ver el reglamento aquí",
  joinTheLaunchpadButton: "Únete al Launchpad",
  tax: "Tasa",
  workWithUs: "Trabaja con nosotros",
  jobOpportunity: "Oportunidad de trabajo",
  workWithUsText1:
    "El sistema Extraconomy ofrece la posibilidad de participar en el desarrollo online y territorial a través de figuras clave (promotor web, embajador, agente comercial, microinfluencer, afiliados del mercado) que se beneficiarán automáticamente de un sistema de comisiones exclusivo, escalable y gratificante.",
  freePlan: "Gratuito",
  salesRepresentativeContract: "Contrato de representante de ventas",
  earnCommissionsAndCredits: "Gane comisiones y créditos",
  developYourNetwork: "Desarrolle su red",
  financialCareerAwards: "Premios de carrera financiera",
  resources: "Recursos",
  blog: "Blog",
  toTheStore: "ACCEDER A LA TIENDA",
  revolutionizeWithExtraconomy: "Revuelva sus negocios con Extraconomy",
  revolutionizeWithExtraconomyDescription:
    "Transforme sus gastos diarios en ganancias y participe de una economia mas sostenible.",
  iWantToStart: "Quiero revolucionar la economia.",
  extrapayBalance: "Saldo ExtraPay",
  extracreditBalance: "Saldo Extracredit",
  viewCashback: "Ver estrato del cashback",
  partnerPlan: "Piano Partner",
  empowerYourBusiness: "Potencie su negocio",
  empowerYourBusinessDescription:
    "Extraconomy es un modelo economico que une tecnologia, comunidad y cooperacion. Creamos un sistema innovador que amplifica el poder economico de las personas y sostiene las actividades locales.",
  comercialIntegration: "Mayor integracion comercial",
  comercialIntegrationDescription:
    "Nuestros instrumentos potencian la integracion entre tiendas y clientes, basandose en el modelo de geolocalizacion.",
  powerfulEconomy: "Una economia mas rapida y potente",
  powerfulEconomyDescription:
    "Reforzamos la economia local y ayudamos a los comercios locales a ganar mas visibilidad.",
  instantProfitDescription:
    "Con el circulo economico activo, comience a ganar dinero desde el momento de la registro y lo amplie con compras e indicaciones.",
  generateCredit: "Generar mas credito",
  generateCreditDescription: "Puede ganar dinero mientras hace las compras diarias.",
  advantages: "Tenemos muchas ventajas para usted",
  createAnAccountForFree: "Cree una cuenta gratuita y descubra todas las ventajas que",
  createAnAccountForFree2: "le ofrece",
  geolocalization: "Geolocalizacion",
  geolocalizationDescription: "Descubra servicios y empresas locales y reforzamos su region.",
  coperativeEconomy: "Economia cooperativa",
  coperativeEconomyDescription:
    "Participe activamente en la construccion de un futuro mas inclusivo.",
  cashback: "Cashback automatico",
  cashbackDescription: "Economice y acumule premios en todas sus compras.",
  pension: "Previdencia Integrativa",
  pensionDescription: "Asegure su futuro con el dinero automatico para salud y previdencia.",
  contactUs: "Contactenos en WhatsApp",
  manyAdvantages: "Existen muchas ventajas!",
  monetaryAlternatives: "Use tambien nuestra alternativa monetaria, economizara mas pagando con ",
  monetaryAlternatives2: "utility-token Extracoin!",
  scrollDown: "Continue a explorar",
  exclusiveResources: "RECURSOS ESPECIAIS",
  whyExtraconomy: "Porque usted debe unirse a Extraconomy?",
  whyExtraconomyDescription:
    "Con los recursos de nuestra red social y economica, usted puede potenciar sus ganancias. Descubra todos los beneficios de Extraconomy y unirse a nosotros.",
  newAcquisition: "Nueva adquisicion",
  newSale: "Nueva venta",
  localSales: "Venta local con retiro.",
  descExtracredit:
    "Registrese y obtenga el Extracredit (vea las condiciones). Use el credito para comprar y/o compartir con sus amigos.",
  descEconomicNetwork:
    "Cree automaticamente una red de usuarios para comprar y vender productos y servicios.",
  descTransactionSafety:
    "Nuestra plataforma es robusta y segura. Usted puede comprar, vender y transferir dinero de manera segura.",
  descFindEverything:
    "Tenemos una herramienta potente para encontrar el producto que usted desea comprar en tan solo unos clics.",
  plansAdvantages: "VANTAGENS DE CADA PLANO",
  chooseYourPlanTitle: "Elija el plano que mejor se adapte a su perfil.",
  chooseYourPlanDescription:
    "Conozca nuestros planes, elija el que mejor se adapte a su perfil y unirse a Extraconomy.",
  noMonthlyFees: "SIN TARIFAS MENSUALES",
  noMonthlyPaymentsDesc: "Usted no tendra que hacer pagos mensuales.",
  partner: "PARTNER",
  naturalPerson: "Persona Fisica",
  salesPlan: "Plano de Ventas",
  selectPlan: "SELECCIONAR",
  legalOrNaturalPerson: "Persona Fisica / Persona Juridica",
  featureShowcase: "Vitrina online",
  featureEconomicNetwork: "Red Economica",
  featureActiveComission: "Comision activa",
  featureEcommerce: "E-commerce personal",
  featureOnlineStore: "Tienda online",
  featureGeolocation: "Geolocalizacion activa",
  featureEvrythingIncluded: "Todo incluso",
  mostPopular: "mas popular",
  doubtsAboutPlans: "Tiene dudas sobre cual plano es el mejor?",
  doubtsAboutPlansDesc:
    "Envie un mensaje a nuestro servicio de clientes y ayudaremos usted a elegir el plano mas adecuado para su perfil.",
  workWithUsSubtitle: "TRABAJE CON NOSOTROS",
  workWithUsTitle: "Sea un Promotor de Extraconomy y multiplique sus ganancias.",
  workWithUsDescription:
    "El sistema Extraconomy ofrece la posibilidad de participar en el desarrollo online y territorial a través de figuras clave (promotores web, embajadores, agentes comerciales, micro-influencers, afiliados de mercado), que se beneficiarán automáticamente de un sistema de comisiones exclusivo, escalable y gratificante.",
  doYouWantToWork: "Quiere ser un Promotor?",
  extracredits: "Reciba 500 R$ en credito extra.",
  moreBonus: "Bonus",
  moreBonusesDescription: "Premios para la carrera financiera.",
  recurrence: "Recurrencia",
  recurrenceDescription: "Desarrolle su red y aumente su recurrencia de ganancias.",
  comissions: "Comisiones",
  comissionsDescription: "Ganhe comisiones e credito.",
  clarify: "Clarifique sus dudas",
  frequentlyAskedQuestionDescription:
    "Recopilamos algunas preguntas y respuestas que pueden ayudarle en su eleccion.",
  doubtsDescription: "Envie un mensaje a nuestro equipo.",
  joinUs: "Unirse a nosotros",
  joinUsDescription: "Regístrese y transformemos juntos la economía.",
  talkWithUs: "Hable con nuestro equipo",
  talkWithUsDescription: "Hable con nuestro equipo comercial.",
  needHelp: "Necesita ayuda?",
  downloadApp: "Descargue nuestro app",
  call: "Llame",
  callDescription: "Esté en contacto con nosotros",
  buyInWhatsapp: "Compre en WhatsApp",
  buyInWhatsappDescription: "Rápido y seguro",
  assistance: "Centro di assistenza",
  assistanceDescription: "Haz tus preguntas",
  followUs: "Siga nuestros canales oficiales",
  shippingMethods: "Modalidades de envio",
  partners: "Partners",
  discoverExtraconomy: "Descubra Extraconomy",
  rewardsProgram: "Programa de recompensa",
  makeMoneyWithUs: "Ganhe dinheiro",
  sellWithUs: "Venda conosco",
  becomeAffiliate: "Seja um afiliado",
  ourPolicies: "Nossas políticas",
  shippingPolicy: "Politica de envio",
  privacyPolicy: "Politica de privacidade",
  returnPolicy: "Politica de devolução",
  returnsAndRefunds: "Devoluções e substituições",
  partnerPlanDescription: "Para quem está commencendo a vender online.",
  sellerPlanDescription: "Para quem deseja aumentar suas vendas.",
  managerPlanDescription: "Para quem deseja ampliar o seu negócio.",
  planSeller: "VENDEDOR",
  register: "Cadastrar-se",
  activateYourDigitalAccess: "Activa tu acceso digital",
  seoDescription: "Una plataforma innovadora en línea de economía cooperativa y circular.",

  // --- Landing page redesign translations (lp2*) ---
  lp2HeroTitle: "¿Vamos juntos a revolucionar la economía?",
  lp2HeroDescription: "Convierte tus gastos diarios en ganancias y forma parte de una economía más sostenible, creada por ti, con quienes te rodean.",
  lp2HeroCta: "Quiero formar parte de esta economía.",
  lp2HeroMicrocopy: "Sin cuota de inscripción para ti. Sin letra pequeña.",
  lp2LocalPartner: "Socio local",
  lp2ComoFuncionaEyebrow: "Cómo funciona",
  lp2ComoFuncionaTitle: "Compra, recibe beneficios y vuelve a usarlos.",
  lp2ComoFuncionaDescription: "Compras en la red, recibes beneficios y puedes usarlos en nuevas compras. Mientras tanto, los negocios cercanos ganan más movimiento.",
  lp2Step1Label: "Compra",
  lp2Step1Title: "Compra dentro de la red",
  lp2Step1Desc: "Encuentra tiendas físicas y vendedores online de Extraconomy.",
  lp2Step2Label: "Recibe",
  lp2Step2Title: "Tu compra genera beneficios",
  lp2Step2Desc: "Recibe cashback en Extracredit y ventajas con Extrapay.",
  lp2Step3Label: "Usa",
  lp2Step3Title: "Úsalo en tu próxima compra",
  lp2Step3Desc: "Tu saldo queda visible en tu cartera y puede usarse en nuevas compras.",
  lp2Step4Label: "Haz que circule",
  lp2Step4Title: "La red se fortalece",
  lp2Step4Desc: "Más compras atraen nuevos negocios y aumentan las opciones para todos.",
  lp2ChoosePathEyebrow: "Elige cómo participar",
  lp2ChoosePathTitle: "Empieza por lo que más sentido tiene para ti.",
  lp2ChoosePathDescription: "Comprar, vender, recomendar negocios o crear tu propia red. Los detalles aparecen cuando quieras saber más.",
  lp2Card1Eyebrow: "Para quien compra",
  lp2Card1Title: "Comprar",
  lp2Card1Desc: "Compra en la red y recibe cashback.",
  lp2Card1Cta: "Saber más",
  lp2Card2Eyebrow: "Para quien vende",
  lp2Card2Title: "Vender",
  lp2Card2Desc: "Ten un escaparate, tienda online o presencia geolocalizada.",
  lp2Card2Cta: "Ver opciones",
  lp2Card3Eyebrow: "Para quien conecta",
  lp2Card3Title: "Promover",
  lp2Card3Desc: "Presenta nuevos negocios y ayuda a que la red crezca.",
  lp2Card3Cta: "Conoce el programa Promotor",
  lp2Card4Eyebrow: "Para empresas",
  lp2Card4Title: "Ofrecer beneficios",
  lp2Card4Desc: "Crea beneficios para empleados, clientes y socios.",
  lp2Card4Cta: "Conoce las soluciones",
  lp2HighlightEyebrow: "Para organizaciones",
  lp2HighlightTitle: "Crear una red",
  lp2HighlightDesc: "Ten tu propio entorno con la tecnología de Extraconomy.",
  lp2HighlightCta: "Conoce White Label",
  lp2NegocioEyebrow: "PARA PARTNERS, SELLERS Y MANAGERS",
  lp2NegocioTitle: "Tenemos muchas ventajas para ti",
  lp2NegocioDescription: "Crea tu cuenta y descubre todas las ventajas que Extraconomy puede ofrecer a tu negocio, con un sistema que une tecnología, comunidad y cooperación.",
  lp2NegocioItem1Title: "Mayor integración comercial",
  lp2NegocioItem1Desc: "Conectamos tiendas y clientes basándonos en un modelo de geolocalización.",
  lp2NegocioItem2Title: "Una economía más rápida y potente",
  lp2NegocioItem2Desc: "Reforzamos el comercio local y ayudamos a los negocios a ganar visibilidad.",
  lp2NegocioItem3Title: "Ganancias instantáneas y constantes",
  lp2NegocioItem3Desc: "Ganas desde el momento del registro y creces con cada venta y recomendación.",
  lp2NegocioItem4Title: "Genera más crédito",
  lp2NegocioItem4Desc: "Gana mientras haces tus propias compras del día a día.",
  lp2StoreEyebrow: "PARA TIENDAS FÍSICAS",
  lp2StoreTitle: "Conviértete en un establecimiento asociado",
  lp2StoreDescription: "Pon tu tienda en el mapa de Extraconomy y haz que te encuentren quienes ya están cerca de ti, con registro gratuito y el mayor rango de cashback del ecosistema.",
  lp2StoreItem1Title: "Registro 100% gratuito",
  lp2StoreItem1Desc: "Sin coste de registro para poner tu tienda física en el mapa.",
  lp2StoreItem2Title: "Geolocalización activa",
  lp2StoreItem2Desc: "Recibe automáticamente a los clientes más cercanos a tu tienda.",
  lp2StoreItem3Title: "Cashback del 1% al 50%",
  lp2StoreItem3Desc: "El mayor rango de cashback entre todos los perfiles del ecosistema.",
  lp2StoreItem4Title: "Tienda online cuando quieras",
  lp2StoreItem4Desc: "Activa tu propio e-commerce bajo las condiciones del plan Seller, cuando tenga sentido.",
  lp2RecursosEyebrow: "RECURSOS ESPECIALES · PARA TODOS",
  lp2RecursosTitle: "El potencial que ya es tuyo desde el primer clic",
  lp2RecursosDescription: "No importa si compras, vendes o gestionas un negocio: estos recursos ya están disponibles en cuanto te unes a Extraconomy.",
  lp2RecursosItem1Title: "Geolocalización",
  lp2RecursosItem1Desc: "Descubre servicios y negocios locales y refuerza tu región.",
  lp2RecursosItem2Title: "Economía cooperativa",
  lp2RecursosItem2Desc: "Participa activamente en la construcción de un futuro más inclusivo.",
  lp2RecursosItem3Title: "Seguridad en las transacciones",
  lp2RecursosItem3Desc: "Compra, vende y transfiere dinero con seguridad.",
  lp2RecursosItem4Title: "Encuentra todo lo que necesitas",
  lp2RecursosItem4Desc: "Una herramienta potente para encontrar lo que deseas en pocos clics.",
  lp2RecursosCashbackLabel: "16,00 € de cashback",
  lp2RecursosLocalSaleLabel: "Venta local con recogida",
  lp2EcoTitle: "Cuantas más personas participan, más fuerte se vuelve el comercio local",
  lp2EcoDescription: "La geolocalización no sirve solo para encontrar: redirige el consumo hacia cerca de ti, en un ciclo que se retroalimenta.",
  lp2EcoStep1Title: "Tú compras local",
  lp2EcoStep1Desc: "Cerca de casa, con cashback garantizado.",
  lp2EcoStep2Title: "El vendedor gana visibilidad",
  lp2EcoStep2Desc: "Mediante la geolocalización, cerca de quienes ya le compran.",
  lp2EcoStep3Title: "Más socios se registran",
  lp2EcoStep3Desc: "Atraídos por el movimiento generado en la región.",
  lp2EcoStep4Title: "Más opciones para ti",
  lp2EcoStep4Desc: "Y el ciclo vuelve a empezar, cada vez más fuerte.",
  lp2ContinueExploring: "Sigue explorando",
  lp2Bar1Title: "Potencia tu negocio",
  lp2Bar1Text: "Descubre qué cambia para quienes tienen un negocio en Extraconomy.",
  lp2Bar2Title: "Y ese potencial no es solo para quien vende.",
  lp2Bar2Text: "Es para todos los que entran en Extraconomy, desde el primer clic.",
  lp2Bar3Title: "Y cuanta más gente participa, más fuerte se vuelve este ciclo.",
  lp2Bar3Text: "Mira cómo cada compra local alimenta el siguiente paso.",
  lp2Bar4Title: "Ya entendiste cómo todo se conecta.",
  lp2Bar4Text: "Es hora de cerrar ese ciclo y elegir tu lugar en él.",
  lp2Bar5Title: "¿Quieres ir más allá y multiplicar tu papel en esta economía?",
  lp2Bar5Text: "Conoce la oportunidad de convertirte en Promotor.",
  lp2PromotorEyebrow: "TRABAJA CON NOSOTROS",
  lp2PromotorTitle: "Conviértete en Promotor de Extraconomy y multiplica tus ganancias",
  lp2PromotorDescription: "Participa en el desarrollo online y territorial de la red. Como Promotor, conectas personas y negocios y recibes comisiones por ventas y alianzas reales.",
  lp2PromotorInfoBox: "Tus ganancias provienen de ventas y alianzas reales: no hay ganancia por simplemente invitar personas.",
  lp2PromotorCard1Title: "Conecta personas",
  lp2PromotorCard1Desc: "Acerca personas y negocios a la red.",
  lp2PromotorCard2Title: "Conecta negocios",
  lp2PromotorCard2Desc: "Amplía la presencia territorial de la red.",
  lp2PromotorCard3Title: "Desarrolla la red",
  lp2PromotorCard3Desc: "Fortalece relaciones comerciales reales.",
  lp2PromotorCard4Title: "Gana con ventas",
  lp2PromotorCard4Desc: "Comisiones vinculadas a ventas y alianzas reales.",
  lp2Profile: "Perfil",
  lp2BadgeProSilver: "Pro Silver",
  lp2BadgeMostPopular: "Start Seller",
  lp2BadgeGeoGold: "Geo Gold",
  lp2BadgeFree: "GRATIS",
  lp2CashbackPartner: "Cashback del 1% al 15%",
  lp2CashbackSeller: "Cashback del 1% al 25%",
  lp2CashbackManager: "Cashback del 1% al 35%",
  lp2CashbackCustomer: "Cashback del 1% al 5%",
  lp2StorePlanDesc: "Tu tienda física, certificada en el mapa.",
  lp2CustomerPlanDesc: "Para quienes quieren comprar y recibir beneficios.",
  lp2FeatureFreeSignup: "Registro gratuito",
  lp2FeatureGeoAccount: "Cuenta geolocalizada",
  lp2FeatureMapCertification: "Certificación en el mapa",
  lp2FeatureEligibleCashback: "Cashback en compras elegibles",
  lp2FeatureExtracreditWallet: "Cartera Extracredit",
  lp2CtaSelect: "Seleccionar",
  lp2CtaCertifyStore: "Certificar tienda",
  lp2CtaCreateAccount: "Crear cuenta",
  lp2PlansEyebrow: "ELIGE TU PERFIL",
  lp2PlansTitle: "Encuentra el perfil que combina contigo",
  lp2PlansDescription: "Customer y Store son gratuitos. Partner, Seller y Manager son planes de venta para distintos momentos de tu negocio. Promotor también es gratuito.",
  lp2PlansCalloutTitle: "Perfiles gratuitos disponibles",
  lp2PlansCalloutDesc: "Customer y Store no pagan para empezar.",
  lp2Faq1Q: "¿Cómo puedo participar en la plataforma?",
  lp2Faq1A: "Solo tienes que crear tu cuenta gratuita, como Customer, para comprar y ganar cashback, o registrando tu negocio si quieres vender.",
  lp2Faq2Q: "¿Es segura la plataforma Extraconomy?",
  lp2Faq2A: "Sí. Todas las transacciones pasan por un sistema de seguridad robusto, y tu saldo en Extracredit siempre está visible en tu cartera.",
  lp2Faq3Q: "¿Existen tarifas de registro para vender?",
  lp2Faq3A: "Customer y Store tienen registro gratuito. Partner, Seller y Manager tienen una tarifa anual, según el tamaño del negocio.",
  lp2Faq4Q: "¿Qué es Extracoin?",
  lp2Faq4A: "Es nuestro token utilitario. Usarlo reduce la comisión de la plataforma en las compras, y se puede negociar en exchanges conectados.",
  lp2Faq5Q: "¿Cómo funciona la red de Promotores?",
  lp2Faq5A: "Los Promotores presentan el ecosistema a nuevos socios y ganan comisión sobre negocios reales, nunca por simplemente invitar personas.",
  lp2FooterColPerfis: "Perfiles",
  lp2FooterColGanheDinheiro: "Gana dinero",
  lp2FooterColPoliticas: "Nuestras políticas",
  lp2LinkDescubra: "Descubre Extraconomy",
  lp2LinkEmpresas: "Extraconomy para Empresas",
  lp2LinkTecnologia: "Tecnología como Servicio",
  lp2LinkMoedas: "Monedas del ecosistema",
  lp2LinkAjuda: "Centro de Ayuda",
  lp2LinkPerfisPlanos: "Perfiles y planes",
  lp2LinkSejaPromotor: "Sé un Promotor",
  lp2LinkPrivacidade: "Política de privacidad",
  lp2LinkTermos: "Términos de uso",
  lp2FooterAppHeading: "Descarga nuestra app",
  lp2CustSeoDescription: "Compra en la red Extraconomy y sigue el cashback y los beneficios en una cuenta gratuita.",
  lp2CustBadge: "Customer · gratis",
  lp2CustH1: "Compra en la red y recibe parte del valor de vuelta.",
  lp2CustHeroDesc: "Tu cuenta es gratuita. Encuentras negocios de Extraconomy, compras y sigues tus beneficios en un solo lugar.",
  lp2CustCta1: "Crear mi cuenta",
  lp2CustCta2: "Entender los beneficios",
  lp2CustBenefitsEyebrow: "Para tu día a día",
  lp2CustBenefitsTitle: "Comprar se vuelve más simple cuando el beneficio es claro.",
  lp2CustBenefitsDesc: "Compras como ya estás acostumbrado. La diferencia es que parte de esa experiencia vuelve a ti dentro de la red.",
  lp2CustBenefit1Title: "Encuentra negocios cercanos",
  lp2CustBenefit1Desc: "Descubre tiendas, productos y servicios que forman parte de Extraconomy.",
  lp2CustBenefit2Title: "Recibe cashback",
  lp2CustBenefit2Desc: "En compras elegibles, parte del valor vuelve a ti en Extracredit.",
  lp2CustBenefit3Title: "Sigue todo en tu cartera",
  lp2CustBenefit3Desc: "Consulta saldos y beneficios sin tener que memorizar reglas.",
  lp2CustExtracreditTitle: "Tu cashback se vuelve fácil de entender.",
  lp2CustExtracreditDesc: "Cuando una compra genera cashback, el valor aparece como Extracredit. 1 Extracredit vale 1 Euro y puede usarse según las reglas de la red.",
  lp2CustExtrapayLink: "Conocer Extrapay",
  lp2CustPraticaLabel: "En la práctica",
  lp2CustStep1Title: "Tú compras",
  lp2CustStep1Desc: "En una tienda o vendedor de la red.",
  lp2CustStep2Title: "El beneficio aparece",
  lp2CustStep2Desc: "El cashback y otros beneficios quedan asociados a tu cuenta.",
  lp2CustStep3Title: "Lo usas cuando tenga sentido",
  lp2CustStep3Desc: "La cartera muestra lo que está disponible.",
  lp2CustFaqEyebrow: "Dudas rápidas",
  lp2CustFaqTitle: "Antes de continuar.",
  lp2CustFaqDesc: "Mira solo lo que suele generar dudas en esta etapa.",
  lp2CustFaq1Q: "¿Necesito pagar para crear una cuenta?",
  lp2CustFaq1A: "No. Customer es el perfil gratuito para quienes compran en la red.",
  lp2CustFaq2Q: "¿Necesito entender Extrapay y EXC antes de comprar?",
  lp2CustFaq2A: "No. Puedes empezar comprando y conocer estos recursos solo cuando aparezcan en tu experiencia.",
  lp2CustFaq3Q: "¿Dónde veo mis beneficios?",
  lp2CustFaq3A: "Los beneficios quedan asociados a tu cuenta y se muestran en la cartera y en las áreas correspondientes de la plataforma.",
  lp2CustCtaTitle: "¿Listo para empezar?",
  lp2CustCtaDesc: "Crea tu cuenta y descubre Extraconomy por la parte que más importa: usarla.",
  lp2CustCtaButton: "Crear cuenta gratuita",
  lp2PartnerSeoDescription: "Plan Partner ProSilver para empezar a vender online en Extraconomy.",
  lp2PartnerBadge: "Partner · ProSilver",
  lp2PartnerPill: "ProSilver",
  lp2PartnerH1: "Empieza a vender online con tu propia vitrina.",
  lp2PartnerHeroDesc: "Para quienes quieren dar el primer paso en las ventas online dentro de Extraconomy.",
  lp2PartnerCta1: "Elegir Partner",
  lp2PartnerCta2: "Comparar planes",
  lp2PartnerBenefitsEyebrow: "Lo que recibes",
  lp2PartnerBenefitsTitle: "Un plan hecho para el momento de tu negocio.",
  lp2PartnerBenefitsDesc: "Mira primero lo que realmente cambia en tu operación. Los detalles completos están disponibles cuando los necesites.",
  lp2PartnerBenefit1Title: "Tu vitrina en la red",
  lp2PartnerBenefit1Desc: "Presenta productos y servicios en un espacio propio.",
  lp2PartnerBenefit2Title: "Hasta 50 anuncios",
  lp2PartnerBenefit2Desc: "Una capacidad inicial para organizar tu oferta sin excesos.",
  lp2PartnerBenefit3Title: "Forma parte del ecosistema",
  lp2PartnerBenefit3Desc: "Vende a personas que ya circulan por la red Extraconomy.",
  lp2PartnerStat1Label: "Capacidad",
  lp2PartnerStat1Value: "Hasta 50 anuncios",
  lp2PartnerStat2Label: "Registro",
  lp2PartnerStat2Value: "€150/año",
  lp2PartnerStat3Label: "Renovación",
  lp2PartnerStat3Value: "€15/año",
  lp2PartnerStatsDisclaimer: "Los valores y condiciones deben confirmarse en el momento de la contratación. Esta página presenta la estructura comercial del plan de forma resumida.",
  lp2PartnerFaqEyebrow: "Dudas rápidas",
  lp2PartnerFaqTitle: "Antes de continuar.",
  lp2PartnerFaqDesc: "Mira solo lo que suele generar dudas en esta etapa.",
  lp2PartnerFaq1Q: "¿Puedo cambiar de plan después?",
  lp2PartnerFaq1A: "La estructura fue organizada para acompañar el crecimiento de la operación. Consulta las condiciones vigentes para cambios de plan.",
  lp2PartnerFaq2Q: "¿Existe una cuota mensual?",
  lp2PartnerFaq2A: "Los planes presentados funcionan con cobro anual y renovación anual, según las condiciones de cada modalidad.",
  lp2PartnerFaq3Q: "¿Necesito decidir ahora?",
  lp2PartnerFaq3A: "No. Compara los planes y elige solo cuando las diferencias tengan sentido para tu operación.",
  lp2PartnerCtaTitle: "¿Es este el momento del Partner?",
  lp2PartnerCtaDesc: "Regístrate y continúa con los datos de tu operación.",
  lp2PartnerCtaButton: "Elegir Partner",
  lp2SellerSeoDescription: "Plan Seller StartSeller para ampliar tu operación de ventas online.",
  lp2SellerBadge: "Seller · StartSeller",
  lp2SellerPill: "Más popular",
  lp2SellerH1: "¿Ya vendes online? Dale más espacio a tu operación.",
  lp2SellerHeroDesc: "Seller es para quienes necesitan ampliar catálogo y presencia sin complicar la rutina.",
  lp2SellerCta1: "Elegir Seller",
  lp2SellerCta2: "Comparar planes",
  lp2SellerBenefitsEyebrow: "Lo que recibes",
  lp2SellerBenefitsTitle: "Un plan hecho para el momento de tu negocio.",
  lp2SellerBenefitsDesc: "Mira primero lo que realmente cambia en tu operación. Los detalles completos están disponibles cuando los necesites.",
  lp2SellerBenefit1Title: "Catálogo más grande",
  lp2SellerBenefit1Desc: "Hasta 500 anuncios para una operación que ya ganó escala.",
  lp2SellerBenefit2Title: "Vende dentro de la red",
  lp2SellerBenefit2Desc: "Conecta tu oferta al marketplace de Extraconomy.",
  lp2SellerBenefit3Title: "Más espacio para crecer",
  lp2SellerBenefit3Desc: "Una estructura intermedia para quienes ya tienen rutina de ventas.",
  lp2SellerStat1Label: "Capacidad",
  lp2SellerStat1Value: "Hasta 500 anuncios",
  lp2SellerStat2Label: "Registro",
  lp2SellerStat2Value: "€350/año",
  lp2SellerStat3Label: "Renovación",
  lp2SellerStat3Value: "€35/año",
  lp2SellerStatsDisclaimer: "Los valores y condiciones deben confirmarse en el momento de la contratación. Esta página presenta la estructura comercial del plan de forma resumida.",
  lp2SellerFaqEyebrow: "Dudas rápidas",
  lp2SellerFaqTitle: "Antes de continuar.",
  lp2SellerFaqDesc: "Mira solo lo que suele generar dudas en esta etapa.",
  lp2SellerFaq1Q: "¿Puedo cambiar de plan después?",
  lp2SellerFaq1A: "La estructura fue organizada para acompañar el crecimiento de la operación. Consulta las condiciones vigentes para cambios de plan.",
  lp2SellerFaq2Q: "¿Existe una cuota mensual?",
  lp2SellerFaq2A: "Los planes presentados funcionan con cobro anual y renovación anual, según las condiciones de cada modalidad.",
  lp2SellerFaq3Q: "¿Necesito decidir ahora?",
  lp2SellerFaq3A: "No. Compara los planes y elige solo cuando las diferencias tengan sentido para tu operación.",
  lp2SellerCtaTitle: "¿Es este el momento del Seller?",
  lp2SellerCtaDesc: "Regístrate y continúa con los datos de tu operación.",
  lp2SellerCtaButton: "Elegir Seller",
  lp2ManagerSeoDescription: "Plan Manager GeoGold para operaciones con catálogo amplio y alcance territorial.",
  lp2ManagerBadge: "Manager · GeoGold",
  lp2ManagerPill: "GeoGold",
  lp2ManagerH1: "Más alcance para una operación que ya creció.",
  lp2ManagerHeroDesc: "Manager reúne recursos para negocios con catálogo amplio y necesidades territoriales mayores.",
  lp2ManagerCta1: "Elegir Manager",
  lp2ManagerCta2: "Comparar planes",
  lp2ManagerBenefitsEyebrow: "Lo que recibes",
  lp2ManagerBenefitsTitle: "Un plan hecho para el momento de tu negocio.",
  lp2ManagerBenefitsDesc: "Mira primero lo que realmente cambia en tu operación. Los detalles completos están disponibles cuando los necesites.",
  lp2ManagerBenefit1Title: "Anuncios ilimitados",
  lp2ManagerBenefit1Desc: "Estructura un catálogo amplio sin un límite de anuncios.",
  lp2ManagerBenefit2Title: "Presencia territorial",
  lp2ManagerBenefit2Desc: "Recursos de geolocalización apoyan operaciones con mayor alcance.",
  lp2ManagerBenefit3Title: "Operación más completa",
  lp2ManagerBenefit3Desc: "Una capa pensada para estructuras comerciales más maduras.",
  lp2ManagerStat1Label: "Capacidad",
  lp2ManagerStat1Value: "Anuncios ilimitados",
  lp2ManagerStat2Label: "Registro",
  lp2ManagerStat2Value: "€1.500/año",
  lp2ManagerStat3Label: "Renovación",
  lp2ManagerStat3Value: "€150/año",
  lp2ManagerStatsDisclaimer: "Los valores y condiciones deben confirmarse en el momento de la contratación. Esta página presenta la estructura comercial del plan de forma resumida.",
  lp2ManagerFaqEyebrow: "Dudas rápidas",
  lp2ManagerFaqTitle: "Antes de continuar.",
  lp2ManagerFaqDesc: "Mira solo lo que suele generar dudas en esta etapa.",
  lp2ManagerFaq1Q: "¿Puedo cambiar de plan después?",
  lp2ManagerFaq1A: "La estructura fue organizada para acompañar el crecimiento de la operación. Consulta las condiciones vigentes para cambios de plan.",
  lp2ManagerFaq2Q: "¿Existe una cuota mensual?",
  lp2ManagerFaq2A: "Los planes presentados funcionan con cobro anual y renovación anual, según las condiciones de cada modalidad.",
  lp2ManagerFaq3Q: "¿Necesito decidir ahora?",
  lp2ManagerFaq3A: "No. Compara los planes y elige solo cuando las diferencias tengan sentido para tu operación.",
  lp2ManagerCtaTitle: "¿Es este el momento del Manager?",
  lp2ManagerCtaDesc: "Regístrate y continúa con los datos de tu operación.",
  lp2ManagerCtaButton: "Elegir Manager",
  lp2StoreSeoDescription: "Registra gratis tu tienda física en el mapa de Extraconomy.",
  lp2StoreBadge: "Store · gratis",
  lp2StoreH1: "Pon tu tienda en el mapa de Extraconomy.",
  lp2StoreHeroDesc: "Registra tu negocio físico de forma gratuita y hazlo más fácil de encontrar para personas que ya forman parte de la red.",
  lp2StoreCta1: "Registrar mi tienda",
  lp2StoreCta2: "Ver cómo funciona",
  lp2StoreBenefitsEyebrow: "Tu tienda en la red",
  lp2StoreBenefitsTitle: "Más visibilidad cerca de quien ya está buscando.",
  lp2StoreBenefitsDesc: "Store es la forma simple de incorporar un negocio físico al ecosistema.",
  lp2StoreBenefit1Title: "Aparece en el mapa",
  lp2StoreBenefit1Desc: "Ayuda a las personas de tu región a encontrar tu negocio.",
  lp2StoreBenefit2Title: "Entra a la red",
  lp2StoreBenefit2Desc: "Forma parte de una comunidad de consumidores, vendedores y promotores.",
  lp2StoreBenefit3Title: "Empieza sin costo",
  lp2StoreBenefit3Desc: "El registro Store es gratuito y está pensado para facilitar la entrada de negocios locales.",
  lp2StoreLocalEyebrow: "Para negocios locales",
  lp2StoreLocalTitle: "Tu presencia física sigue siendo importante.",
  lp2StoreLocalDesc: "Extraconomy usa la tecnología para acercar personas a negocios reales. Store ayuda a que tu tienda forme parte de ese descubrimiento local.",
  lp2StoreLocalPhotoAlt: "Negocio local atendiendo a un cliente",
  lp2StoreFaqEyebrow: "Dudas rápidas",
  lp2StoreFaqTitle: "Antes de continuar.",
  lp2StoreFaqDesc: "Mira solo lo que suele generar dudas en esta etapa.",
  lp2StoreFaq1Q: "¿El registro Store es gratuito?",
  lp2StoreFaq1A: "Sí. Store es la entrada gratuita para negocios físicos.",
  lp2StoreFaq2Q: "¿Necesito vender online?",
  lp2StoreFaq2A: "No. El perfil Store existe para la presencia física. Si quieres vender online más adelante, puedes conocer los planes Partner, Seller y Manager.",
  lp2StoreFaq3Q: "¿La tienda aparece para personas cercanas?",
  lp2StoreFaq3A: "La propuesta del perfil incluye presencia geolocalizada dentro de la red, según los recursos disponibles en la plataforma.",
  lp2StoreCtaTitle: "Tu tienda ya puede formar parte.",
  lp2StoreCtaDesc: "Registra los datos básicos del negocio y empieza con el perfil gratuito Store.",
  lp2StoreCtaButton: "Registrar tienda",
  lp2WhiteLabelSeoDescription: "Crea una red propia con la infraestructura White Label de Extraconomy.",
  lp2WhiteLabelBadge: "White Label",
  lp2WhiteLabelH1: "Una red con la identidad de tu organización.",
  lp2WhiteLabelHeroDesc: "Usa la tecnología Extraconomy para reunir personas, negocios y beneficios en un entorno propio.",
  lp2WhiteLabelCta1: "Quiero hablar",
  lp2WhiteLabelCta2: "Ver cómo funciona",
  lp2WhiteLabelBenefitsEyebrow: "Tu red, tu identidad",
  lp2WhiteLabelBenefitsTitle: "La tecnología queda detrás. Tu comunidad queda al frente.",
  lp2WhiteLabelBenefitsDesc: "Asociaciones, empresas y organizaciones pueden usar la infraestructura Extraconomy sin tener que explicar toda la complejidad técnica a sus participantes.",
  lp2WhiteLabelBenefit1Title: "Identidad propia",
  lp2WhiteLabelBenefit1Desc: "La experiencia puede asumir la identidad visual y la comunicación de la organización.",
  lp2WhiteLabelBenefit2Title: "Red de negocios",
  lp2WhiteLabelBenefit2Desc: "Reúne a participantes y negocios en un entorno común.",
  lp2WhiteLabelBenefit3Title: "Beneficios conectados",
  lp2WhiteLabelBenefit3Desc: "Estructura ventajas y relaciones dentro de la lógica de tu ecosistema.",
  lp2WhiteLabelStepsEyebrow: "De la idea al uso",
  lp2WhiteLabelStepsTitle: "Tres pasos para empezar.",
  lp2WhiteLabelStepsDesc: "La implementación puede profundizarse después. Primero necesitamos entender quién forma parte de tu red y qué necesita hacer posible.",
  lp2WhiteLabelStep1Label: "01 · Entender",
  lp2WhiteLabelStep1Title: "¿Quién forma parte de tu red?",
  lp2WhiteLabelStep1Desc: "Empezamos por las personas, negocios y relaciones que ya existen.",
  lp2WhiteLabelStep2Label: "02 · Configurar",
  lp2WhiteLabelStep2Title: "¿Qué beneficios tienen sentido?",
  lp2WhiteLabelStep2Desc: "La estructura se organiza en torno al objetivo de la organización.",
  lp2WhiteLabelStep3Label: "03 · Lanzar",
  lp2WhiteLabelStep3Title: "Una experiencia simple de usar.",
  lp2WhiteLabelStep3Desc: "La complejidad técnica queda entre bastidores; la participación necesita seguir siendo clara.",
  lp2WhiteLabelCtaTitle: "¿Quieres crear una red propia?",
  lp2WhiteLabelCtaDesc: "Cuéntanos a quién reúnes y qué quieres hacer posible.",
  lp2WhiteLabelCtaButton: "Hablar sobre White Label",
  lp2PromoterSeoDescription: "Sé Promotor Extraconomy y ayuda a la red a crecer en tu región.",
  lp2PromoterBadge: "Promotor · gratis",
  lp2PromoterH1: "Conecta buenos negocios a la red.",
  lp2PromoterHeroDesc: "El Promotor presenta Extraconomy, acerca personas y empresas y ayuda al ecosistema a crecer de forma local.",
  lp2PromoterCta1: "Quiero ser Promotor",
  lp2PromoterCta2: "Entender el papel",
  lp2PromoterBenefitsEyebrow: "Lo que haces",
  lp2PromoterBenefitsTitle: "Tú abres puertas. La red hace el resto.",
  lp2PromoterBenefitsDesc: "El papel del Promotor es acercar nuevos negocios a Extraconomy y apoyar el primer contacto con el ecosistema.",
  lp2PromoterBenefit1Title: "Presenta la idea",
  lp2PromoterBenefit1Desc: "Explica de forma simple cómo un negocio puede entrar a la red.",
  lp2PromoterBenefit2Title: "Crea conexiones reales",
  lp2PromoterBenefit2Desc: "Acerca a personas y empresas que puedan generar valor entre sí.",
  lp2PromoterBenefit3Title: "Fortalece tu región",
  lp2PromoterBenefit3Desc: "Ayuda a la red a crecer con negocios que existen cerca de ti.",
  lp2PromoterPayEyebrow: "Remuneración",
  lp2PromoterPayTitle: "La remuneración acompaña la actividad real.",
  lp2PromoterPayDesc: "Las reglas de remuneración forman parte del plan de compensación y están ligadas a las condiciones y actividades previstas por Extraconomy. El registro, por sí solo, no debe tratarse como una venta.",
  lp2PromoterChecklistTitle: "Antes de empezar",
  lp2PromoterChecklist1: "Entiende cómo funciona Extraconomy para explicarlo con claridad.",
  lp2PromoterChecklist2: "Conecta negocios que tengan una adherencia real a la red.",
  lp2PromoterChecklist3: "Consulta el plan de compensación antes de asumir cualquier expectativa de ganancia.",
  lp2PromoterCtaTitle: "¿Quieres ayudar a la red a crecer?",
  lp2PromoterCtaDesc: "Empieza por el registro y conoce las reglas antes de actuar.",
  lp2PromoterCtaButton: "Quiero ser Promotor",
  lp2EmpresasSeoDescription: "Lleva Extraconomy a colaboradores, clientes y socios con soluciones de welfare, ESG y relación B2B.",
  lp2EmpresasBadge: "Para empresas",
  lp2EmpresasH1: "Beneficios que tienen sentido para quienes están contigo.",
  lp2EmpresasHeroDesc: "Lleva Extraconomy a colaboradores, clientes y socios con soluciones de welfare, ESG y relación B2B.",
  lp2EmpresasCta1: "Hablar con Extraconomy",
  lp2EmpresasCta2: "Conocer White Label",
  lp2EmpresasBenefitsEyebrow: "Soluciones para empresas",
  lp2EmpresasBenefitsTitle: "Una red de beneficios puede empezar de formas diferentes.",
  lp2EmpresasBenefitsDesc: "Elige el punto que combina con tu estrategia y profundiza solo donde tenga sentido.",
  lp2EmpresasBenefit1Title: "Welfare y beneficios",
  lp2EmpresasBenefit1Desc: "Crea ventajas para las personas vinculadas a tu empresa.",
  lp2EmpresasBenefit2Title: "ESG con relación local",
  lp2EmpresasBenefit2Desc: "Acerca el consumo, los negocios y el impacto dentro de una red más cercana.",
  lp2EmpresasBenefit3Title: "Relaciones B2B",
  lp2EmpresasBenefit3Desc: "Conecta empresas y oportunidades comerciales dentro del ecosistema.",
  lp2EmpresasWhiteLabelEyebrow: "También para asociaciones",
  lp2EmpresasWhiteLabelTitle: "¿Quieres una red con la identidad de tu organización?",
  lp2EmpresasWhiteLabelDesc: "La solución White Label usa la infraestructura Extraconomy para crear un entorno propio de participantes, negocios y beneficios.",
  lp2EmpresasWhiteLabelLink: "Conocer White Label",
  lp2EmpresasStepEyebrow: "Un paso a la vez",
  lp2EmpresasStepTitle: "Empieza por el problema que tu empresa quiere resolver.",
  lp2EmpresasStepDesc: "Nuestra conversación parte de la necesidad: beneficios, relación, red comercial o entorno propio.",
  lp2EmpresasCtaTitle: "¿Entendemos tu caso?",
  lp2EmpresasCtaDesc: "Cuéntanos qué necesita tu empresa. La solución viene después.",
  lp2EmpresasCtaButton: "Hablar con el equipo",
  lp2PlanosSeoDescription: "Compara Store, Partner, Seller y Manager en Extraconomy.",
  lp2PlanosBreadcrumb: "Planes",
  lp2PlanosEyebrow: "Planes",
  lp2PlanosH1: "Elige según el tamaño de tu operación.",
  lp2PlanosHeroDesc:
    "Empieza gratis con Store o elige una estructura de venta online. Compara solo lo que cambia entre los planes.",
  lp2PlanosCompareEyebrow: "Comparación simple",
  lp2PlanosCompareTitle: "Mira las diferencias que realmente importan.",
  lp2PlanosCompareDesc: "Si un plan tiene sentido, visita su página para conocer los detalles.",
  lp2PlanosStoreDesc: "Tienda física en el mapa.",
  lp2PlanosStoreItem1: "Registro gratuito",
  lp2PlanosStoreItem2: "Cuenta geolocalizada",
  lp2PlanosStoreItem3: "Certificación en el mapa",
  lp2PlanosStoreCta: "Conocer Store",
  lp2PlanosPartnerDesc: "€150/año · hasta 50 anuncios.",
  lp2PlanosPartnerItem1: "Vitrina online",
  lp2PlanosPartnerItem2: "Red económica",
  lp2PlanosPartnerItem3: "Renovación €15/año",
  lp2PlanosPartnerCta: "Conocer Partner",
  lp2PlanosSellerDesc: "€350/año · hasta 500 anuncios.",
  lp2PlanosSellerItem1: "E-commerce personal",
  lp2PlanosSellerItem3: "Renovación €35/año",
  lp2PlanosSellerCta: "Conocer Seller",
  lp2PlanosManagerDesc: "€1.500/año · anuncios ilimitados.",
  lp2PlanosManagerItem1: "Tienda online",
  lp2PlanosManagerItem2: "Geolocalización",
  lp2PlanosManagerItem3: "Renovación €150/año",
  lp2PlanosManagerCta: "Conocer Manager",
  lp2PlanosDisclaimer: "Los valores y condiciones deben confirmarse al momento de la contratación.",
  lp2PlanosCtaTitle: "¿Aún tienes dudas?",
  lp2PlanosCtaDesc: "Empieza con el Store gratuito o conoce cada plan con calma.",
  lp2PlanosCtaButton: "Empezar con Store",
  lp2SobreSeoDescription: "Conoce la idea detrás de Extraconomy y cómo su red conecta personas y negocios.",
  lp2SobreBadge: "Sobre Extraconomy",
  lp2SobreH1: "Una red creada para hacer circular el valor.",
  lp2SobreHeroDesc: "Extraconomy acerca a quienes compran, quienes venden y quienes crean nuevas conexiones para fortalecer relaciones económicas más cercanas.",
  lp2SobreCta1: "Ver dónde encajo",
  lp2SobreCta2: "Conocer empresas",
  lp2SobreIdeaEyebrow: "Nuestra idea",
  lp2SobreIdeaTitle: "La tecnología solo tiene sentido cuando mejora relaciones reales.",
  lp2SobreIdeaDesc: "Por eso, Extraconomy reúne marketplace, beneficios, fidelización y herramientas para ayudar a personas, negocios y organizaciones a participar en la misma red.",
  lp2SobreValue1Title: "Personas en el centro",
  lp2SobreValue1Desc: "La experiencia empieza por lo que alguien quiere hacer, no por la tecnología que hay detrás.",
  lp2SobreValue2Title: "Negocios reales",
  lp2SobreValue2Desc: "Tiendas físicas y vendedores online forman parte de la misma economía conectada.",
  lp2SobreValue3Title: "Valor en circulación",
  lp2SobreValue3Desc: "Los beneficios incentivan nuevas relaciones dentro de la propia red.",
  lp2SobreInfraEyebrow: "De un marketplace a una infraestructura",
  lp2SobreInfraTitle: "La misma lógica puede atender a personas, empresas y comunidades.",
  lp2SobreInfraDesc: "El marketplace es una parte importante. Extrapay, soluciones corporativas y White Label amplían esta base a otros contextos sin perder la idea central: conectar personas y negocios de forma sencilla.",
  lp2SobreInfraImgAlt: "Negocio local de la economía Extraconomy",
  lp2SobreCtaTitle: "¿Dónde encajas en esta red?",
  lp2SobreCtaDesc: "Elige según la actividad que tenga sentido para ti hoy.",
  lp2SobreCtaButton: "Conocer perfiles",
  lp2VideoEyebrow: "Conoce Extraconomy",
  lp2VideoTitle: "Una economía que se queda con quien participa.",
  lp2VideoDescription: "En pocos minutos, nuestro fundador presenta el ecosistema que conecta ciudadanos, comercios, profesionales y asociaciones en una misma red de beneficios.",
  lp2VideoLanguageNote: "Video en italiano, con subtítulos automáticos en tu idioma. Si no aparecen, actívalos con el botón CC del reproductor.",
  lp2VideoPlay: "Ver el video",
};

export default landingDictES;
